/* @sravni/react-design-system version 0.2.59 */
var VARIANTS = {
    OUTLINED: 'outlined',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TEXT: 'text',
};

export { VARIANTS };
//# sourceMappingURL=variants.js.map
